<template>
  <div>
    <titulo-modulo titulo="Convênios" />
    <v-progress-linear indeterminate v-if="carregando"></v-progress-linear>
    <template v-else>
      <v-row v-if="declaracao">
        <v-col>
          <v-btn
            v-if="declaracao.id > 0"
            rounded
            color="info"
            @click="imprimirDeclaracao"
            >Imprimir declaração</v-btn
          >
          <v-btn
            v-else
            rounded
            color="success"
            @click="emitirDeclaracao"
            :loading="emitindoDeclaracao"
            >Emitir declaração</v-btn
          >
        </v-col>
      </v-row>

      <v-alert :type="classAlertaDeclaracao" text class="mt-3">
        {{ informeDeclaracao }}
      </v-alert>

      <v-row>
        <v-col md="4" lg="4" sm="6" v-for="(convenio, i) in convenios" :key="i">
          <CardConvenio :convenio="convenio" />
        </v-col>
      </v-row>
    </template>
  </div>
</template>

<script>
import TituloModulo from "../../components/TituloModulo.vue";
import CardConvenio from "@/views/convenios/components/CardConvenio";
import axios from "axios";
import { dateFormat, getLinkImpressao, getToken } from "@/global";

export default {
  components: {
    CardConvenio,
    TituloModulo,
  },
  data: () => ({
    carregando: false,
    convenios: [],
    declaracao: null,
    informeDeclaracao: "",
    classAlertaDeclaracao: "info",
    emitindoDeclaracao: false,
  }),
  methods: {
    async getConvenios() {
      this.convenios = [];
      await axios
        .get(`colaborador/convenios`)
        .then((res) => {
          if (res.data.success) this.convenios = res.data.data;
          else this.$toasted.error(res.data.msg);
        })
        .catch((e) =>
          this.$toasted.error(`Houve um erro ao carregar os convênios. ${e}`)
        );
    },
    async getDeclaracao() {
      this.informeDeclaracao = "";
      this.declaracao = null;
      await axios
        .get(`colaborador/convenios?funcao=DECLARACAO`)
        .then((res) => {
          if (res.data.success) {
            this.declaracao = res.data.data;

            if (this.declaracao.id > 0) {
              this.classAlertaDeclaracao = "success";
              this.informeDeclaracao = `Declaração nº ${
                this.declaracao.id
              } com validade até ${dateFormat(this.declaracao.validade)}`;
            } else {
              this.classAlertaDeclaracao = "info";
              this.informeDeclaracao = "Nenhuma declaração emitida";
            }
          }
        })
        .catch((e) => {
          this.classAlertaDeclaracao = "error";
          this.informeDeclaracao = `Houve um erro ao carregar a declaração. ${e}`;
        });
    },
    async emitirDeclaracao() {
      this.emitindoDeclaracao = true;
      await axios
        .post(`colaborador/convenios?funcao=EMITIR-DECLARACAO`)
        .then((res) => {
          if (res.data.success) {
            this.$router.go();
          } else {
            this.$toasted.error(res.data.msg);
          }
        })
        .catch((e) =>
          this.$toasted.error(`Houve um erro ao emitir a declaração. ${e}`)
        )
        .finally(() => (this.emitindoDeclaracao = false));
    },
    imprimirDeclaracao() {
      window.open(
        `${getLinkImpressao()}/declaracao-convenio-pdf.php?token=${getToken()}`,
        "blank"
      );
    },
  },
  async mounted() {
    this.carregando = true;
    await this.getConvenios();
    await this.getDeclaracao();
    this.carregando = false;
  },
};
</script>

<style>
</style>